import { ApplicationConfig, importProvidersFrom, inject, provideBrowserGlobalErrorListeners, provideZoneChangeDetection, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { provideFirebaseApp, initializeApp, FirebaseApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideAnalytics } from '@angular/fire/analytics';
import { environment } from '../environments/environment';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { getAnalytics, setAnalyticsCollectionEnabled } from '@angular/fire/analytics';
import { provideServerRendering } from '@angular/ssr';
import { provideHttpClient } from '@angular/common/http';
export const appConfig: ApplicationConfig = {
  providers: [
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideHttpClient(),
    // provideServerRendering(),
    providePrimeNG({
      theme: {
        preset: Aura
      }
    }),
    provideAnalytics(() => {
      const app = inject(FirebaseApp);    // get the already-created app
      const analytics = getAnalytics(app);
      // const analytics = getAnalytics();
      setAnalyticsCollectionEnabled(analytics, true);
      analytics.app.automaticDataCollectionEnabled = true;
      return analytics;
    }),

    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideRouter(routes), provideClientHydration(withEventReplay())
  ]
};
